import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const ClientProjectRoute = ({ children }) => {
  const { isLoading, user } = useContext(AuthContext);

  if (isLoading) return null;

  const userType = user?.user_type;
  if (userType !== "client" && userType !== "client_member") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ClientProjectRoute;
